import React, { useEffect, useState } from 'react';
import { ImCross } from 'react-icons/im';
import { FaCheck } from 'react-icons/fa';

const PasswordValidator = (props) => {
    const [containsLowerCase, setContainsLowerCase] = useState(false);
    const [containsUpperCase, setContainsUpperCase] = useState(false);
    const [containsNumber, setContainsNumber] = useState(false);
    const [containsSpecialCharacter, setContainsSpecialCharacter] =
        useState(false);
    const [containsGoodLength, setContainsGoodLength] = useState(false);

    // UseEffect For Checking Upppercase
    useEffect(() => {
        if (props.passwordData !== null && props.passwordData !== undefined) {
            const { passwordData } = props;

            if (
                passwordData.contains &&
                passwordData.contains.length > 0 &&
                passwordData.contains.includes('uppercase')
            ) {
                setContainsUpperCase(true);
            } else {
                setContainsUpperCase(false);
            }
        } else {
            setContainsLowerCase(false);
            setContainsUpperCase(false);
            setContainsNumber(false);
            setContainsSpecialCharacter(false);
            setContainsGoodLength(false);
        }
    }, [props.passwordData]);

    // UseEffect For Checking Lowercase
    useEffect(() => {
        if (props.passwordData !== null && props.passwordData !== undefined) {
            const { passwordData } = props;

            if (
                passwordData.contains &&
                passwordData.contains.length > 0 &&
                passwordData.contains.includes('lowercase')
            ) {
                setContainsLowerCase(true);
            } else {
                setContainsLowerCase(false);
            }
        } else {
            setContainsLowerCase(false);
            setContainsUpperCase(false);
            setContainsNumber(false);
            setContainsSpecialCharacter(false);
            setContainsGoodLength(false);
        }
    }, [props.passwordData]);

    // UseEffect For Checking Number
    useEffect(() => {
        if (props.passwordData !== null && props.passwordData !== undefined) {
            const { passwordData } = props;

            if (
                passwordData.contains &&
                passwordData.contains.length > 0 &&
                passwordData.contains.includes('number')
            ) {
                setContainsNumber(true);
            } else {
                setContainsNumber(false);
            }
        } else {
            setContainsLowerCase(false);
            setContainsUpperCase(false);
            setContainsNumber(false);
            setContainsSpecialCharacter(false);
            setContainsGoodLength(false);
        }
    }, [props.passwordData]);

    // UseEffect For Checking Symbol
    useEffect(() => {
        if (props.passwordData !== null && props.passwordData !== undefined) {
            const { passwordData } = props;

            if (
                passwordData.contains &&
                passwordData.contains.length > 0 &&
                passwordData.contains.includes('symbol')
            ) {
                setContainsSpecialCharacter(true);
            } else {
                setContainsSpecialCharacter(false);
            }
        } else {
            setContainsLowerCase(false);
            setContainsUpperCase(false);
            setContainsNumber(false);
            setContainsSpecialCharacter(false);
            setContainsGoodLength(false);
        }
    }, [props.passwordData]);

    // UseEffect For Checking Length
    useEffect(() => {
        if (props.passwordData !== null && props.passwordData !== undefined) {
            const { passwordData } = props;

            if (passwordData.length >= 8) {
                setContainsGoodLength(true);
            } else {
                setContainsGoodLength(false);
            }
        } else {
            setContainsLowerCase(false);
            setContainsUpperCase(false);
            setContainsNumber(false);
            setContainsSpecialCharacter(false);
            setContainsGoodLength(false);
        }
    }, [props.passwordData]);

    return (
        <div>
            <p className='primary'>Passwords must have at least</p>
            <ul>
                <li>
                    8 characters
                    {containsGoodLength ? (
                        <FaCheck style={{ marginLeft: '10px' }} size={12} />
                    ) : (
                        <ImCross style={{ marginLeft: '10px' }} size={12} />
                    )}
                </li>
            </ul>
            <p className='primary mb-0'>
                Contain at least one of the following:
            </p>
            <ul className='mt-0'>
                <li>
                    Uppercase letters and lowercase letters{' '}
                    {containsLowerCase && containsUpperCase ? (
                        <FaCheck style={{ marginLeft: '10px' }} size={12} />
                    ) : (
                        <ImCross style={{ marginLeft: '10px' }} size={12} />
                    )}
                </li>
                <li>
                    Numbers{' '}
                    {containsNumber ? (
                        <FaCheck style={{ marginLeft: '10px' }} size={12} />
                    ) : (
                        <ImCross style={{ marginLeft: '10px' }} size={12} />
                    )}
                </li>
                <li>
                    Special Characters{' '}
                    {containsSpecialCharacter ? (
                        <FaCheck style={{ marginLeft: '10px' }} size={12} />
                    ) : (
                        <ImCross style={{ marginLeft: '10px' }} size={12} />
                    )}
                </li>
            </ul>
        </div>
    );
};

export default PasswordValidator;
